import CustomButton from './CustomButton';

export {
  CustomButton
}; 


// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/util/index.js